<ng-container *ngIf="isHeadingSectionVisible">
  <mable-heading
    heading="h2"
    headingStyle="h3"
    >Need more help?</mable-heading
  >
  <mable-button
    category="link"
    (onClick)="serviceAgreementGuide()"
    data-testid="agreement-form-step4-view-our-service-agreement-guide-button"
    >View our service agreement guide
  </mable-button>
</ng-container>

<div
  class="ion-margin agreements"
  *ngIf="otherUser?.coordinator?.truncatedName"
>
  <mable-heading heading="h4">Information sharing</mable-heading>
  <p>
    The client is {{ otherUser.displayName }} by {{ organisationName }}
    <ng-container *ngIf="otherUser.coordinator">
      with the help from {{ otherUser.coordinator.truncatedName }}</ng-container
    >.
  </p>
  <p>By offering this agreement to {{ otherUser.displayName }}:</p>
  <ol>
    <li>
      I understand that the documents on my profile, including my police check, will now be available to
      {{ organisationName }}.
    </li>
    <li>
      I understand that client information in my support notes or incident reports will be available to
      {{ organisationName }}.
    </li>
  </ol>
</div>
